module.exports = __webpack_public_path__ + "img/pax_black.8f7cfd87.svg";